/**
 * Communication entre la recherche d'habilitations (Appbar) et le menu latéral
 * (Habilitation) : permet de mettre en évidence l'entrée sélectionnée.
 */
export const MENU_FOCUS_EVENT = 'anybank:focus-menu';

export interface MenuFocusDetail {
  codmen: string;
}

/**
 * Le menu latéral est construit à partir de la longueur du code menu
 * (1, 3, 5, 7...). Les ancêtres d'une entrée sont donc ses préfixes.
 */
export function getMenuAncestorKeys(codmen: string): string[] {
  const ancestors: string[] = [];
  for (let length = 1; length < codmen.length; length += 2) {
    ancestors.push(codmen.substring(0, length));
  }
  return ancestors;
}

export function requestMenuFocus(codmen: string): void {
  window.dispatchEvent(new CustomEvent<MenuFocusDetail>(MENU_FOCUS_EVENT, { detail: { codmen } }));
}
